// Global Types
import type {
  $Translate,
} from 'common.language';

// import type {
//   $Language,
// } from 'common.language';
// Global Components
import * as React from 'react';
import {
  NavItem,
  NavLink,
} from 'reactstrap';

// Helpers
// import _ from 'lodash';
// import {
//   i18next,
//   language,
// } from 'common.language';

// Components
import ClockDialog from '../../../dialog/ClockDialog';

// Types
import type {
  $ReducerState,
} from '../../../../redux';

import type {
  $SetStartAction,
} from '../../../../redux/modules/main/actions';

export type $OwnProps = $Translate;

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = {
  // setLanguage: $SetLanguageAction,
  setStart: $SetStartAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

class RightButtonsView extends React.Component<$Props> {
  //   renderLanguageSelectItem(className: string) {
  //     const {
  //       setLanguage,
  //     } = this.props;
  //
  //     const languages: Array<$Language> = _.values(language);
  //
  //     return (languages.length > 1 ? (
  //       <UncontrolledDropdown
  //         nav
  //         inNavbar
  //         className={className}
  //       >
  //         <DropdownToggle
  //           nav
  //           className="text-uppercase font-icon"
  //         >
  //           {i18next.language}
  //         </DropdownToggle>
  //         <DropdownMenu
  //           style={{
  //             minWidth: 'auto',
  //           }}
  //           className="p-0"
  //         >
  //           {languages.map((l: $Language) => (
  //             <DropdownItem
  //               key={l}
  //               className="text-uppercase py-2 py-2 font-icon"
  //               onClick={() => setLanguage({
  //                 language: l,
  //               })}
  //             >
  //               {l}
  //             </DropdownItem>
  //           ))}
  //         </DropdownMenu>
  //       </UncontrolledDropdown>
  //     ) : (
  //       <NavItem className={className}>
  //         <NavLink className="text-uppercase py-2 px-2 font-icon">
  //           {i18next.language}
  //         </NavLink>
  //       </NavItem>
  //     ));
  //   }

  renderRegattaClockItem() {
    const {
      main,
      setStart,
    } = this.props;

    return (
      <ClockDialog
        id={'clock-dialog'}
        setStart={(value) => setStart(value)}
        start={main.start}
      >
        <NavLink
          className={'regatta-clock-button'}
          href={'#'}
          id={'clock-button'}
        >
          <em className={'icon-clock'} />
        </NavLink>
      </ClockDialog>
    );
  }

  render() {
    return (
      <>
        <NavItem nav>
          {this.renderRegattaClockItem()}
        </NavItem>
        {/* this.renderLanguageSelectItem('d-none d-md-block') */}
        {/*
          <UncontrolledDropdown
            className="d-block d-md-none"
            inNavbar
            nav
          >
            <DropdownToggle nav>
              <em className="icon-options" />
            </DropdownToggle>
            <DropdownMenu>
              <div className="d-flex align-items-center justify-content-center">
                <NavItem>
                  {this.renderRegattaClockItem()}
                </NavItem>
                {this.renderLanguageSelectItem('')}
              </div>
            </DropdownMenu>
          </UncontrolledDropdown>
        */}
      </>
    );
  }
}

export default RightButtonsView;
